var confused = confused || {};
(function ($) {
    confused.quickquote = {
        /* get a quick quote 'object'*/
        createQuickQuoteConnection: function (options) {
            return {
                events: $.extend({
                    url: '',
                    connected: function () {
                    },
                    message: function (activity) {
                    },
                    error: function () {
                    },
                    complete: function () {
                    }
                }, options),
                /* open the connection, the connected event will fire when done */
                start: function (jsonData) {
                    var self = this;
                    self._connection = $.connection(self.events.url);
                    self._connection.received(function (data) {
                        var message = JSON.parse(data);
                        if (message.HasError != null && message.HasError === true) {
                            self.events.error();
                            return;
                        }

                        if (message.Activity != null) {
                            var activity = message.Activity;
                            if (activity.Prices != null) {
                                var prices = activity.Prices;
                                if (prices.length > 0) {
                                    self.events.message(activity);
                                }
                            }

                            if (activity.StillWaiting !== true) {
                                self._connection.stop();
                                self.events.complete();
                            }
                        }
                    });
                    self._connection.error(function (data) {
                        self.events.error(data, -1, -1);
                    });
                    self._connection.start().done(function () {
                        self.events.connected();
                        self._connection.send(jsonData);
                    });
                },
                /* close the current connection */
                abort: function () {
                    this._connection.stop();
                }
            };
        }
    };
} (jQuery));